import { render, staticRenderFns } from "./NCCR.vue?vue&type=template&id=049c2f0a&scoped=true&"
import script from "./NCCR.vue?vue&type=script&lang=js&"
export * from "./NCCR.vue?vue&type=script&lang=js&"
import style0 from "./NCCR.vue?vue&type=style&index=0&id=049c2f0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049c2f0a",
  null
  
)

export default component.exports